import type { AiAccountMonthlyCostResponse } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { aiCostsKeys } from "@/hooks/queryKeys";

import { getAccountMonthlyAiCost } from "../api/aiCosts.api";

export function useAccountMonthlyAiCost(
  accountId: number,
  month: string,
  enabled: boolean,
): UseQueryResult<AiAccountMonthlyCostResponse, Error> {
  return useQuery({
    enabled,
    queryFn: () => getAccountMonthlyAiCost(accountId, month),
    queryKey: aiCostsKeys.accountMonth(accountId, month),
  });
}
